import { render } from "./JelouAdmin.vue?vue&type=template&id=5c2cf18a&scoped=true"
import script from "./JelouAdmin.vue?vue&type=script&lang=js"
export * from "./JelouAdmin.vue?vue&type=script&lang=js"

import "./JelouAdmin.vue?vue&type=style&index=0&id=5c2cf18a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2cf18a"]])

export default __exports__